import React from 'react'

const Important = ({ className }: { className?: string }) => {
    return (
        <svg className={className} fill="none" height="26" viewBox="0 0 26 26" width="26" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.32153 23.125H15.9234M5.36086 7.59704C6.30119 4.08704 8.9884 2 12.6224 2C16.2565 2 18.9437 4.0865 19.884 7.59704C20.8244 11.1076 19.0704 14.7064 15.9234 16.5237V20.4844H9.32153V16.5237C5.17778 14.5445 4.41999 11.107 5.36086 7.59704Z" stroke="#fdd835" strokeLinecap="round" strokeLinejoin="round"></path>
            <path d="M7.00702 9.40692C7.00702 9.40692 6.58127 4.74913 12.363 4" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeOpacity="0.5"></path>
        </svg>
    )
}

export default Important



